export enum Side {
  short = 'short',
  long = 'long',
}

export enum MarginType {
  isolated = 'isolated',
  cross = 'cross',
}

export enum OrderType {
  market = 'market',
  limit = 'limit',
  stopLimit = 'stopLimit',
  stopMarket = 'stopMarket',
}

export const MAX_14_BIT_SC_USD = 163.83; // 14-bit maximum value with 2 decimal places used by smart contract

export const DAY_MS = 24 * 60 * 60 * 1000; // milliseconds in a day
